module.exports = __webpack_public_path__ + "img/no-image-error.7569b0c8.png";